import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import ItemList from 'flarum/common/utils/ItemList';
export default class ComposeHero extends Component {
  view() {
    const _this$attrs = this.attrs,
      item = _this$attrs.item,
      translationPrefix = _this$attrs.translationPrefix,
      className = _this$attrs.className;
    const isEditing = !!item.id();
    return m("div", {
      className: "".concat(className, " Hero")
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h2", {
      className: "Hero-title"
    }, app.translator.trans("".concat(translationPrefix, ".").concat(isEditing ? 'edit' : 'add', "_title"))), m("div", {
      className: "".concat(className, "-controls")
    }, this.controlItems().toArray()))));
  }
  controlItems() {
    const items = new ItemList();
    const _this$attrs2 = this.attrs,
      item = _this$attrs2.item,
      managerRoute = _this$attrs2.managerRoute,
      managerIcon = _this$attrs2.managerIcon,
      managerLabel = _this$attrs2.managerLabel,
      viewRoute = _this$attrs2.viewRoute,
      viewIcon = _this$attrs2.viewIcon,
      viewLabel = _this$attrs2.viewLabel;
    items.add('manager', m(LinkButton, {
      icon: managerIcon,
      className: "Button Button--secondary",
      itemClassName: "App-primaryControl",
      href: app.route(managerRoute)
    }, managerLabel));
    if (item.exists && viewRoute && viewLabel) {
      items.add('view', m(LinkButton, {
        icon: viewIcon || 'far fa-arrow-up-right-from-square',
        className: "Button Button--secondary",
        itemClassName: "App-primaryControl",
        href: app.route(viewRoute, {
          id: item.id()
        })
      }, viewLabel));
    }
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/ComposeHero', ComposeHero);